import { LoadingContainer, LoadingContainerBox } from './Loading.styles';
import loadingAnimation from '../../../assets/animation/Loading-Animation---Fast.json';
import Lottie from 'lottie-react';

export const Loading = () => {
  return (
    <LoadingContainer data-testid={'loading'}>
      <LoadingContainerBox>
        <Lottie animationData={loadingAnimation} />
      </LoadingContainerBox>
    </LoadingContainer>
  );
};
